import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimesheetEditComponent } from './timesheet-edit/timesheet-edit.component';
import { TimesheetListComponent } from './timesheet-list/timesheet-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ColumnChooserService, FilterService, GridModule, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { MaskedTextBoxModule, NumericTextBoxAllModule, NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { TimesheetRoutingModule } from './timesheet-routing.module';
import { MyDatePickerModule } from 'mydatepicker';
import { TimesheetComponent } from './timesheet.component';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { EvvtimesheetModule } from '../evvtimesheet/evvtimesheet.module';
@NgModule({
  declarations: [TimesheetComponent, TimesheetEditComponent, TimesheetListComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    GridModule,
    ReactiveFormsModule,
    MultiselectDropdownModule,
    NumericTextBoxModule,
    NumericTextBoxAllModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    MyDatePickerModule,
    TimesheetRoutingModule,
    DropDownListAllModule,
    
  ],
  providers: [ColumnChooserService, PageService, SortService, FilterService, ResizeService],
})
export class TimesheetModule { }
